import type { InvoiceMultipleRowOldNewProps } from 'entities/history';
import { InvoiceHistoryRowKey } from 'entities/history';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { getKeys } from 'shared/lib/object';

import { OldToNewValue } from './OldToNewValue';

export function InvoiceMultipleRowOldNewValues({ data }: InvoiceMultipleRowOldNewProps) {
  return (
    <div data-testid="TestId__several_rows_old_to_new_value">
      {getKeys(data).map((key) => {
        return (
          <div
            className="flex items-center border-b border-slate-100 py-2 text-xs last:border-0"
            key={key}
            {...getDataAutoTestAttributes([`several-rows-old_to_new-value-${key.toLowerCase().replace(/\s/g, '-')}`])
              .attributes}
          >
            <span className="mr-[6px] font-semibold">{InvoiceHistoryRowKey[key]}:</span>
            {key === 'items' || key === 'refundItems' ? (
              <OldToNewValue
                type="number"
                oldValue={data[key]?.old ?? 0}
                newValue={data[key]?.new ?? 0}
              />
            ) : (
              <OldToNewValue
                type="money"
                oldValue={data[key]?.old ?? 0}
                newValue={data[key]?.new ?? 0}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
